import React from 'react'
import Marquee from "react-fast-marquee"
import wmap from '../../assets/svg/map.svg'
import clients from '../../data/clients'

const Clients = () => {
  return (
    <section id="clients" style={{ padding: '0 0 32px' }}>
      <div className="container">
        <div className="flex aic" style={{ height: 300 }}>
          <h2 className="title-intro c-white upp">Our Projects</h2>
          <div className="map"><img src={wmap} alt="Our Projects" /></div>
        </div>
      </div>
      <div className="bg-white" style={{ padding: '60px 0' }}>
        <Marquee speed={50} gradient={false} pauseOnHover={true}>
          {clients.map((item) => (
            <div key={item.id} style={{ margin: '0 40px', textAlign: 'center' }}>
              <img src={item.pic} alt={item.name} width={80} height={80} className='obfc greyscale' />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  )
}

export {Clients}
